import { ButtonMain } from '@/modules/common/components/button';
import { $selectedRecipeStore } from '@/modules/mixing/store/recipes.store';
import { useStore } from 'effector-react';
import styles from './index.module.sass';

export const PresellContentModal = ({
  action,
  mixes,
  mixAction,
}: {
  action: () => void;
  mixes: number[];
  mixAction: () => void;
}) => {
  const activeWarehouse = useStore($selectedRecipeStore);
  const isStationary = activeWarehouse?.type === '1';
  return (
    <div className={styles.root}>
      <h2 className={styles.modalHeader}>Внимание!</h2>
      <p>
        {Array.isArray(mixes) && mixes.length > 0 ? (
          <>
            {isStationary ? 'Объем' : 'Рукав'} используется в {mixes.length}{' '}
            {getMixesDeclension(mixes.length)}. <br />
          </>
        ) : (
          ''
        )}
        Вы можете продать данный {isStationary ? 'объем' : 'рукав'} отдельно, но это
        может нарушить рецептуру миксов, содержащих зерновую культуру из данного{' '}
        {isStationary ? 'объема' : 'рукава'}.
      </p>
      <div className={styles.actionsArea}>
        <ButtonMain
          className={styles.submit}
          onClick={action}
          label="подтвердить продажу"
        />
        <span style={{ userSelect: 'none' }}>либо</span>
        <ButtonMain
          className={styles.cancel}
          onClick={mixAction}
          label={
            isStationary
              ? 'посмотреть наилучшие миксы, в которых участвует этот объем'
              : 'посмотреть наилучшие миксы, в которых участвует этот рукав'
          }
        />
      </div>
    </div>
  );
};

function getMixesDeclension(count: number) {
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return 'миксах';
  } else if (lastDigit === 1) {
    return 'миксе';
  } else if (lastDigit >= 2 && lastDigit <= 4) {
    return 'миксах';
  } else {
    return 'миксах';
  }
}
